import NextNProgress from 'nextjs-progressbar';
import React from 'react';
import {colors} from 'theme';

export const RouteLoader = React.memo(() => {
  return (
    <NextNProgress
      color={colors.pink}
      startPosition={0.2}
      stopDelayMs={200}
      height={2}
      showOnShallow={false}
      options={{showSpinner: false}}
    />
  );
});
